import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';
import EmergencyPopup from './EmergencyPopup';
import MasaHillsChatbot from './MasaHillsChatbot';

const Layout = () => {
    const [showChatbot, setShowChatbot] = useState(false);

    useEffect(() => {
        if (showChatbot) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, [showChatbot]);

    return (
        <>
            <Navbar />
            <motion.main
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                className="min-h-screen bg-lightGrey"
            >
                <main className="flex-1 p-4 md:p-6 overflow-y-auto bg-gray-50">
                    <Outlet />
                </main>
            </motion.main>
            <Footer />
            <EmergencyPopup />

            {/* Floating Chat Button */}
            <button
                onClick={() => setShowChatbot(true)}
                className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-40"
                aria-label="Open chat support"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
            </button>

            {/* Chatbot Modal */}
            {showChatbot && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="relative bg-white rounded-2xl shadow-2xl p-0 max-h-[95vh] w-full max-w-lg flex flex-col" style={{ height: '95vh', maxHeight: '720px' }}>
                        <button
                            onClick={() => setShowChatbot(false)}
                            className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center z-50 font-bold text-lg"
                            aria-label="Close chat"
                        >
                            ×
                        </button>
                        <MasaHillsChatbot />
                    </div>
                </div>
            )}
        </>
    );
};

export default Layout;
